import { render, staticRenderFns } from "./DwellTimeParameterPageTable.vue?vue&type=template&id=074db980"
import script from "./DwellTimeParameterPageTable.vue?vue&type=script&lang=js"
export * from "./DwellTimeParameterPageTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports